import { useEffect } from 'react';
import { IBayesianNetworksParameters } from './bayesian-networks-interfaces';
import { useBayesianNetworksStore } from './dal/bayesian-networks-store';
import BayesianNetworksView from './ui/bayesian-networks-view';
import BayesianNetworksParameters from './ui/bayesian-networks-parameters';

const initialParameters: IBayesianNetworksParameters = {
    "rules": [
        [ "A", 0.6 ],
        [ "B|A", 0.95 ],
        [ "B|~A", 0.1 ],
        [ "C|A", 0.5 ],
        [ "C|~A", 0.8 ],
        [ "D|A,B", 0.95 ],
        [ "D|~A,B", 0.3 ],
        [ "D|A,~B", 0.9 ],
        [ "D|~A,~B", 0.1 ],
        [ "E|D", 0.1 ],
        [ "E|~D", 0.8 ]
    ],
    "targets": [ "A,B,C,D,E", "E|A", "A|E" ],
    "arrows": [
        [ "A", "B" ],
        [ "A", "C" ],
        [ "A", "D" ],
        [ "D", "E" ]
    ]
};

const BayesianNetworksHome = () => {

    const params = useBayesianNetworksStore(store => store.params);
    const setParams = useBayesianNetworksStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">Bayesian Networks</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <BayesianNetworksParameters />
                        <BayesianNetworksView />
                    </div>
                }
            </div>

        </div>
    )
};

export default BayesianNetworksHome;
